module.exports = __webpack_public_path__ + "static/media/results.790bd9ed.svg";